import { RowChipDto } from "@/dtos";
import { Chip } from "@/entities";
import { getChipOperatorOption, getChipStatusOption } from "@/helpers/options";

export const formatRowChipDto = (chips: Chip[]) => {
    return chips.map(x => {
        const row: RowChipDto = {
            ...x,
            operator_label: getChipOperatorOption(parseInt(x.operator)).label,
            status_label: getChipStatusOption(parseInt(x.status)).label,
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}